angular.module('app').controller('availablePromoCodeNotificationCtrl', ['$scope', '$translate', 'Alerts', function($scope, $translate, Alerts) {
  $scope.onCopySuccess = function() {
    $scope.$parent.dismiss();
    Alerts.success($translate.instant('notifications.available_promo_code.code_copied_successfully'));
  };

  $scope.onCopyError = function() {}
}]);
